import { ThemeType, LanguageType } from '../types/command';

// Gerçek IP adresini getiren fonksiyon
export const getRealIpAddress = async (): Promise<string> => {
  try {
    // ipify API'sini kullanarak IP adresini al
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    return data.ip;
  } catch (error) {
    console.error('IP adresini alırken hata oluştu:', error);
    // Hata durumunda bilinmeyen IP göster
    return 'unknown';
  }
};

// Yazı efekti için gecikme fonksiyonu
export const delay = (ms: number): Promise<void> => {
  return new Promise(resolve => setTimeout(resolve, ms));
};

// Yazı efekti
export const typewriterEffect = async (
  text: string,
  onCharacter: (char: string) => void,
  speed: number = 30
): Promise<void> => {
  for (let i = 0; i < text.length; i++) {
    onCharacter(text[i]);
    await delay(speed);
  }
};

// CV indirme
export const downloadCV = (language: 'tr' | 'en'): void => {
  const publicUrl = process.env.PUBLIC_URL || '';
  const cvUrl = `${publicUrl}/assets/cv/AnilorhanCV_${language.toUpperCase()}.pdf`;

  const a = document.createElement('a');
  a.href = cvUrl;
  a.download = `AnilorhanCV_${language.toUpperCase()}.pdf`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

// Tema uygulama
export const applyTheme = (theme: ThemeType): void => {
  // Mevcut tema sınıflarını temizle
  document.body.classList.remove('cmd-theme', 'powershell-theme', 'ubuntu-theme');
  
  // Yeni tema sınıfını ekle
  document.body.classList.add(`${theme}-theme`);
  
  // Tema tercihini localStorage'a kaydet
  localStorage.setItem('preferred-theme', theme);
  
  // Fontları yükle
  loadThemeFont(theme);
};

// Tema fontunu dinamik olarak yükle
const loadThemeFont = (theme: ThemeType): void => {
  // Önceki font stil etiketlerini temizle
  const previousFontLinks = document.querySelectorAll('link[data-font-theme]');
  previousFontLinks.forEach(link => link.remove());
  
  // Tema için doğru fontları yükle
  switch (theme) {
    case 'ubuntu':
      // Ubuntu Mono font
      const ubuntuLink = document.createElement('link');
      ubuntuLink.rel = 'stylesheet';
      ubuntuLink.href = 'https://fonts.googleapis.com/css2?family=Ubuntu+Mono:wght@400;700&display=swap';
      ubuntuLink.setAttribute('data-font-theme', 'ubuntu');
      document.head.appendChild(ubuntuLink);
      break;
      
    case 'powershell':
      // Cascadia Code PL (PowerShell için)
      const cascadiaCodeLink = document.createElement('link');
      cascadiaCodeLink.rel = 'stylesheet';
      cascadiaCodeLink.href = 'https://cdn.jsdelivr.net/npm/@fontsource/cascadia-code@4.2.1/index.css';
      cascadiaCodeLink.setAttribute('data-font-theme', 'cascadia-code');
      document.head.appendChild(cascadiaCodeLink);
      break;
      
    case 'cmd':
      // Cascadia Mono (CMD için)
      const cascadiaMonoLink = document.createElement('link');
      cascadiaMonoLink.rel = 'stylesheet';
      cascadiaMonoLink.href = 'https://cdn.jsdelivr.net/npm/@fontsource/cascadia-mono@4.2.1/index.css';
      cascadiaMonoLink.setAttribute('data-font-theme', 'cascadia-mono');
      document.head.appendChild(cascadiaMonoLink);
      break;
  }
};

// Dil değiştirme - terminal içeriğini koruyarak
export const changeLanguage = (language: LanguageType): void => {
  // localStorage'a kaydet
  localStorage.setItem('preferred-language', language);
  
  // Sayfa yenilemesi YAPMA, bunun yerine özel bir olay tetikle
  // Bu şekilde terminal içeriği korunacak
  const languageChangeEvent = new CustomEvent('terminal-language-change', { detail: { language } });
  document.dispatchEvent(languageChangeEvent);
};

// URL'leri açma
export const openUrl = (url: string): void => {
  window.open(url, '_blank');
};

// Link fonksiyonları
export const openGithub = (): void => openUrl('https://github.com/Anil-Orhan');
export const openLinkedin = (): void => openUrl('https://www.linkedin.com/in/anılorhan/');
export const openTwitter = (): void => openUrl('https://twitter.com/anilorhandev');

// Divider'ı referans ile verilen metne göre ölçeklendir
export const getDynamicDivider = (referenceText: string, dividerChar: string = '─'): string => {
  // Referans metin uzunluğunu hesapla (minimum 40, maksimum 120 karakter)
  // Genişlik çarpanı ekle (2.5x) - tipik olarak terminal genişliğine uyması için
  const baseLength = Math.min(Math.max(referenceText.length, 40), 120);
  const referenceLength = Math.floor(baseLength * 2.5);
  
  // Verilen karakteri referans uzunluğu kadar tekrarla
  return dividerChar.repeat(referenceLength);
};

// Terminal genişliğini dolduran divider oluştur
export const getFullWidthDivider = (dividerChar: string = '─'): string => {
  // Varsayılan terminal genişliği - genellikle 80-120 karakter arası
  const terminalWidth = 100;
  
  // Verilen karakteri terminal genişliği kadar tekrarla
  return dividerChar.repeat(terminalWidth);
}; 